import { createEnum } from './enum-kit.js';
import { enumLabelMap, enumValues } from './utils.js';
export { CAR_SOURCE_VEHICLE_CONDITION_LABEL_MAP as VEHICLE_CONDITION_LABEL_MAP, CAR_SOURCE_VEHICLE_CONDITIONS as VEHICLE_CONDITIONS, carSourceVehicleConditionEnum as vehicleConditionEnum, } from './car-source.js';
export const vehicleStatusEnum = createEnum({
    PURCHASED: ['purchased', '已采购', 'blue'],
    LOCKED: ['locked', '已锁车', 'cyan'],
    RESERVED: ['reserved', '已预订', 'orange'],
    SOLD: ['sold', '已销售', 'green'],
    RETURNED: ['returned', '退回', 'red'],
});
export const VEHICLE_STATUSES = enumValues(vehicleStatusEnum);
export const VEHICLE_STATUS_LABEL_MAP = enumLabelMap(vehicleStatusEnum);
export const inventoryStatusEnum = createEnum({
    PENDING_PICKUP: ['pending_pickup', '待提车', 'gold'],
    IN_TRANSIT: ['in_transit', '在途', 'blue'],
    PENDING_STORAGE: ['pending_storage', '待入库', 'orange'],
    IN_STOCK: ['in_stock', '在库', 'green'],
    OUT_OF_STOCK: ['out_of_stock', '已出库', 'default'],
});
export const INVENTORY_STATUSES = enumValues(inventoryStatusEnum);
export const INVENTORY_STATUS_LABEL_MAP = enumLabelMap(inventoryStatusEnum);
/** Current identity quality of a tenant-owned physical vehicle master. */
export const vehicleIdentityStatusEnum = createEnum({
    PENDING: ['pending', '待确认', 'gold'],
    CONFIRMED: ['confirmed', '已确认', 'green'],
    CONFLICT: ['conflict', '待处理冲突', 'red'],
});
export const VEHICLE_IDENTITY_STATUSES = enumValues(vehicleIdentityStatusEnum);
export const VEHICLE_IDENTITY_STATUS_LABEL_MAP = enumLabelMap(vehicleIdentityStatusEnum);
export const vehicleAvailabilityStatusEnum = createEnum({
    AVAILABLE: ['available', '可用', 'green'],
    RESERVED: ['reserved', '已占用', 'orange'],
    UNAVAILABLE: ['unavailable', '不可用', 'default'],
});
export const VEHICLE_AVAILABILITY_STATUSES = enumValues(vehicleAvailabilityStatusEnum);
export const VEHICLE_AVAILABILITY_STATUS_LABEL_MAP = enumLabelMap(vehicleAvailabilityStatusEnum);
export const vehicleTransportStatusEnum = createEnum({
    NOT_TRANSPORTING: ['not_transporting', '未运输', 'default'],
    IN_TRANSIT: ['in_transit', '运输中', 'blue'],
    ARRIVED: ['arrived', '已到达', 'green'],
});
export const VEHICLE_TRANSPORT_STATUSES = enumValues(vehicleTransportStatusEnum);
export const VEHICLE_TRANSPORT_STATUS_LABEL_MAP = enumLabelMap(vehicleTransportStatusEnum);
export const vehicleLocationTypeEnum = createEnum({
    WAREHOUSE: ['warehouse', '仓储', 'blue'],
    PORT: ['port', '港口', 'cyan'],
    TRANSIT: ['transit', '运输中', 'orange'],
    CUSTOMER: ['customer', '客户', 'purple'],
    OTHER: ['other', '其他', 'default'],
});
export const VEHICLE_LOCATION_TYPES = enumValues(vehicleLocationTypeEnum);
export const VEHICLE_LOCATION_TYPE_LABEL_MAP = enumLabelMap(vehicleLocationTypeEnum);
/** Allowed only on lifecycle/ledger/audit references, never as a core relation. */
export const vehicleItemTypeEnum = createEnum({
    CONTRACT: ['contract_vehicle_item', '合同车辆明细', 'blue'],
    PURCHASE_REQUIREMENT: [
        'purchase_requirement_vehicle_item',
        '采购需求车辆明细',
        'cyan',
    ],
    VEHICLE_INBOUND: ['vehicle_inbound_vehicle_item', '入库车辆明细', 'green'],
    VEHICLE_OUTBOUND: ['vehicle_outbound_vehicle_item', '出库车辆明细', 'orange'],
    LOGISTICS: ['logistics_vehicle_item', '物流车辆明细', 'blue'],
    PROFORMA_INVOICE: ['proforma_invoice_vehicle_item', 'PI 车辆明细', 'purple'],
    EXPORT_LICENSE: ['export_license_vehicle_item', '出口许可证车辆明细', 'gold'],
    CUSTOMS_DECLARATION: [
        'customs_declaration_vehicle_item',
        '报关车辆明细',
        'cyan',
    ],
    VEHICLE_DELIVERY: ['vehicle_delivery_vehicle_item', '交付车辆明细', 'green'],
    VEHICLE_CANCELLATION: [
        'vehicle_cancellation_vehicle_item',
        '注销车辆明细',
        'orange',
    ],
    TAX_REFUND: ['tax_refund_vehicle_item', '退税车辆明细', 'purple'],
    PAYMENT_REQUEST: ['payment_request_vehicle_item', '付款申请车辆明细', 'blue'],
    RECEIPT_REQUEST: ['receipt_request_vehicle_item', '收款申请车辆明细', 'blue'],
});
export const VEHICLE_ITEM_TYPES = enumValues(vehicleItemTypeEnum);
export const VEHICLE_ITEM_TYPE_LABEL_MAP = enumLabelMap(vehicleItemTypeEnum);
export const vehicleLifecycleEventTypeEnum = createEnum({
    INBOUND_CONFIRMED: ['inbound_confirmed', '入库确认', 'green'],
    OUTBOUND_RESERVED: ['outbound_reserved', '出库占用', 'orange'],
    OUTBOUND_COMPLETED: ['outbound_completed', '完成出库', 'default'],
    OUTBOUND_RELEASED: ['outbound_released', '释放出库占用', 'blue'],
    LOGISTICS_DEPARTED: ['logistics_departed', '物流发运', 'blue'],
    LOGISTICS_ARRIVED: ['logistics_arrived', '物流到达', 'green'],
    DELIVERY_CONFIRMED: ['delivery_confirmed', '车辆交付确认', 'green'],
    CANCELLATION_CONFIRMED: ['cancellation_confirmed', '车辆注销确认', 'red'],
    BUSINESS_STATUS_CHANGED: [
        'business_status_changed',
        '车辆业务状态变更',
        'blue',
    ],
    VIN_MERGED: ['vin_merged', 'VIN 主档归并', 'purple'],
});
export const VEHICLE_LIFECYCLE_EVENT_TYPES = enumValues(vehicleLifecycleEventTypeEnum);
export const VEHICLE_LIFECYCLE_EVENT_TYPE_LABEL_MAP = enumLabelMap(vehicleLifecycleEventTypeEnum);
export const vehicleReservationStatusEnum = createEnum({
    RESERVED: ['reserved', '已占用', 'orange'],
    RELEASED: ['released', '已释放', 'blue'],
    COMPLETED: ['completed', '已完成', 'green'],
    CANCELLED: ['cancelled', '已取消', 'default'],
    EXPIRED: ['expired', '已过期', 'red'],
});
export const VEHICLE_RESERVATION_STATUSES = enumValues(vehicleReservationStatusEnum);
export const VEHICLE_RESERVATION_STATUS_LABEL_MAP = enumLabelMap(vehicleReservationStatusEnum);
export const vehicleLedgerDirectionEnum = createEnum({
    INFLOW: ['inflow', '流入', 'green'],
    OUTFLOW: ['outflow', '流出', 'red'],
});
export const VEHICLE_LEDGER_DIRECTIONS = enumValues(vehicleLedgerDirectionEnum);
export const VEHICLE_LEDGER_DIRECTION_LABEL_MAP = enumLabelMap(vehicleLedgerDirectionEnum);
export const vehicleBusinessTypeEnum = createEnum({
    CONTRACT: ['contract', '合同', 'blue'],
    DOCUMENT: ['document', '单证管理', 'green'],
    LOGISTICS: ['logistics', '物流', 'cyan'],
    EXPORT_LICENSE: ['export-license', '出口许可证', 'gold'],
    CUSTOMS_DECLARATION: ['customs-declaration', '报关', 'blue'],
    VEHICLE_DELIVERY: ['vehicle-delivery', '车辆交付', 'green'],
    VEHICLE_CANCELLATION: ['vehicle-cancellation', '车辆注销', 'orange'],
    TAX_REFUND: ['tax-refund', '车辆退税', 'purple'],
    VEHICLE_INBOUND: ['vehicle-inbound', '车辆入库', 'geekblue'],
    VEHICLE_OUTBOUND: ['vehicle-outbound', '车辆出库', 'magenta'],
});
export const VEHICLE_BUSINESS_TYPES = enumValues(vehicleBusinessTypeEnum);
export const VEHICLE_BUSINESS_TYPE_LABEL_MAP = enumLabelMap(vehicleBusinessTypeEnum);
/** Vehicle-wide business state dimensions persisted on the vehicle master. */
export const vehicleBusinessStateTypeEnum = createEnum({
    EXPORT_LICENSE: ['export_license', '许可证状态', 'gold'],
    CUSTOMS_DECLARATION: ['customs_declaration', '报关状态', 'blue'],
    VEHICLE_CANCELLATION: ['vehicle_cancellation', '注销状态', 'orange'],
    TAX_REFUND: ['tax_refund', '退税状态', 'purple'],
    DOMESTIC_LOGISTICS: ['domestic_logistics', '国内物流状态', 'cyan'],
    INTERNATIONAL_LOGISTICS: [
        'international_logistics',
        '国际物流状态',
        'geekblue',
    ],
    PURCHASE: ['purchase', '采购状态', 'blue'],
    SALE: ['sale', '销售状态', 'green'],
});
export const VEHICLE_BUSINESS_STATE_TYPES = enumValues(vehicleBusinessStateTypeEnum);
export const VEHICLE_BUSINESS_STATE_TYPE_LABEL_MAP = enumLabelMap(vehicleBusinessStateTypeEnum);
export const vehicleBusinessProgressStatusEnum = createEnum({
    PENDING: ['pending', '待处理', 'default'],
    PROCESSING: ['processing', '处理中', 'processing'],
    COMPLETED: ['completed', '已完成', 'success'],
});
export const VEHICLE_BUSINESS_PROGRESS_STATUSES = enumValues(vehicleBusinessProgressStatusEnum);
export const VEHICLE_BUSINESS_PROGRESS_STATUS_LABEL_MAP = enumLabelMap(vehicleBusinessProgressStatusEnum);
export const VEHICLE_BUSINESS_STATE_ALLOWED_STATUSES = {
    [vehicleBusinessStateTypeEnum.EXPORT_LICENSE]: VEHICLE_BUSINESS_PROGRESS_STATUSES,
    [vehicleBusinessStateTypeEnum.CUSTOMS_DECLARATION]: VEHICLE_BUSINESS_PROGRESS_STATUSES,
    [vehicleBusinessStateTypeEnum.VEHICLE_CANCELLATION]: VEHICLE_BUSINESS_PROGRESS_STATUSES,
    [vehicleBusinessStateTypeEnum.TAX_REFUND]: VEHICLE_BUSINESS_PROGRESS_STATUSES,
    [vehicleBusinessStateTypeEnum.DOMESTIC_LOGISTICS]: VEHICLE_BUSINESS_PROGRESS_STATUSES,
    [vehicleBusinessStateTypeEnum.INTERNATIONAL_LOGISTICS]: VEHICLE_BUSINESS_PROGRESS_STATUSES,
    [vehicleBusinessStateTypeEnum.PURCHASE]: [
        vehicleBusinessProgressStatusEnum.PENDING,
        vehicleBusinessProgressStatusEnum.COMPLETED,
    ],
    [vehicleBusinessStateTypeEnum.SALE]: [
        vehicleBusinessProgressStatusEnum.PENDING,
        vehicleBusinessProgressStatusEnum.COMPLETED,
    ],
};
export const VEHICLE_BUSINESS_STATE_STATUS_LABEL_MAP = {
    [vehicleBusinessStateTypeEnum.EXPORT_LICENSE]: {
        pending: '待办理',
        processing: '办理中',
        completed: '已办理',
    },
    [vehicleBusinessStateTypeEnum.CUSTOMS_DECLARATION]: {
        pending: '待申报',
        processing: '申报中',
        completed: '已申报',
    },
    [vehicleBusinessStateTypeEnum.VEHICLE_CANCELLATION]: {
        pending: '待注销',
        processing: '注销中',
        completed: '已注销',
    },
    [vehicleBusinessStateTypeEnum.TAX_REFUND]: {
        pending: '待退税',
        processing: '退税中',
        completed: '已退税',
    },
    [vehicleBusinessStateTypeEnum.DOMESTIC_LOGISTICS]: {
        pending: '待运输',
        processing: '运输中',
        completed: '已送达',
    },
    [vehicleBusinessStateTypeEnum.INTERNATIONAL_LOGISTICS]: {
        pending: '待运输',
        processing: '运输中',
        completed: '已送达',
    },
    [vehicleBusinessStateTypeEnum.PURCHASE]: {
        pending: '待采购',
        completed: '已采购',
    },
    [vehicleBusinessStateTypeEnum.SALE]: {
        pending: '待销售',
        completed: '已销售',
    },
};
export function getVehicleBusinessStateStatusLabel(stateType, status) {
    const labels = VEHICLE_BUSINESS_STATE_STATUS_LABEL_MAP[stateType];
    return (labels[status] ??
        VEHICLE_BUSINESS_PROGRESS_STATUS_LABEL_MAP[status] ??
        status);
}
export const vehicleModelAiRecognitionTypeEnum = createEnum({
    BRAND_ENGLISH: ['brand_english', '品牌英文'],
    MODEL_NAME_ENGLISH: ['model_name_english', '车型英文'],
    COLOR_ENGLISH: ['color_english', '外观和内饰英文'],
    EXTERIOR_COLOR_ENGLISH: ['exterior_color_english', '外观颜色英文'],
    INTERIOR_COLOR_ENGLISH: ['interior_color_english', '内饰颜色英文'],
    LOCATION_ENGLISH: ['location_english', '车辆所在地英文'],
    EXTRA_PACK_ENGLISH: ['extra_pack_english', '加装包英文'],
    CONFIGURATION_ENGLISH: ['configuration_english', '配置说明英文'],
    PORT_ENGLISH: ['port_english', '港口英文'],
});
export const VEHICLE_MODEL_AI_RECOGNITION_TYPES = enumValues(vehicleModelAiRecognitionTypeEnum);
export const VEHICLE_MODEL_AI_RECOGNITION_TYPE_LABEL_MAP = enumLabelMap(vehicleModelAiRecognitionTypeEnum);
export const accessoryCategoryEnum = createEnum({
    KEY: ['key', '钥匙', 'gold'],
    DOCUMENT: ['document', '文件类', 'blue'],
    ITEM: ['item', '物品类', 'green'],
});
export const ACCESSORY_CATEGORIES = enumValues(accessoryCategoryEnum);
export const ACCESSORY_CATEGORY_LABEL_MAP = enumLabelMap(accessoryCategoryEnum);
export const vehicleAttachmentTypeEnum = createEnum({
    QUALIFICATION_CERTIFICATE: ['qualification_certificate', '合格证', 'green'],
    CERTIFICATE_OF_CONFORMITY: [
        'certificate_of_conformity',
        '一致性证书',
        'green',
    ],
    ENVIRONMENTAL_LIST: ['environmental_list', '环保清单', 'green'],
    REGISTRATION_CERTIFICATE: ['registration_certificate', '登记证', 'green'],
    DRIVING_LICENSE: ['driving_license', '行驶证', 'green'],
    INSPECTION_REPORT: ['inspection_report', '检测报告', 'green'],
    ELECTRONIC_POLICY: ['electronic_policy', '电子保单', 'green'],
    CERTIFICATE_OF_ORIGIN: ['certificate_of_origin', '原产地证明', 'green'],
    MOTOR_VEHICLE_INVOICE: ['motor_vehicle_invoice', '机动车发票', 'orange'],
    USED_CAR_INVOICE: ['used_car_invoice', '二手车发票', 'orange'],
    VAT_INVOICE: ['vat_invoice', '增值税发票', 'orange'],
    EXPORT_LICENSE: ['export_license', '出口许可证', 'green'],
    CUSTOMS_DECLARATION: ['customs_declaration', '报关单', 'green'],
    VEHICLE_CANCELLATION_PROOF: [
        'vehicle_cancellation_proof',
        '车辆注销证明',
        'green',
    ],
    PACKING_LIST: ['packing_list', '装箱单', 'green'],
    RELEASE_NOTICE: ['release_notice', '放行通知书', 'green'],
    INTERNATIONAL_LOGISTICS_WAYBILL: [
        'international_logistics_waybill',
        '国际物流运输单',
        'green',
    ],
    DOMESTIC_LOGISTICS_WAYBILL: [
        'domestic_logistics_waybill',
        '国内物流运输单',
        'green',
    ],
    PURCHASE_CONTRACT: ['purchase_contract', '采购合同', 'green'],
    DOMESTIC_TRADE_CONTRACT: ['domestic_trade_contract', '内贸合同', 'green'],
    DOMESTIC_PURCHASE_CONTRACT: [
        'domestic_purchase_contract',
        '内贸采购合同',
        'green',
    ],
    DOMESTIC_SALE_CONTRACT: ['domestic_sale_contract', '内贸销售合同', 'green'],
    FOREIGN_TRADE_CONTRACT: ['foreign_trade_contract', '外贸合同', 'green'],
    FOREIGN_PURCHASE_CONTRACT: [
        'foreign_purchase_contract',
        '外贸采购合同',
        'green',
    ],
    FOREIGN_SALE_CONTRACT: ['foreign_sale_contract', '外贸销售合同', 'green'],
    PURCHASE_PAYMENT_VOUCHER: ['purchase_payment_voucher', '采购付款单', 'green'],
    FOREIGN_TRADE_CONTRACT_RECEIPT_VOUCHER: [
        'foreign_trade_contract_receipt_voucher',
        '外贸合同回款单',
        'green',
    ],
    PROFORMA_INVOICE: ['proforma_invoice', 'PI', 'green'],
});
export const VEHICLE_ATTACHMENT_TYPES = enumValues(vehicleAttachmentTypeEnum);
export const VEHICLE_ATTACHMENT_TYPE_LABEL_MAP = enumLabelMap(vehicleAttachmentTypeEnum);
//# sourceMappingURL=vehicle.js.map